import type { LocaleObject } from "@nuxtjs/i18n/dist/module";

export const useLocalizedDateTime = (
  date: MaybeRefOrGetter<Date | undefined>,
  type: "date" | "time" | "dateTime" | "longDate",
) => {
  const { locale, locales } = useI18n();

  const localizedDateTime = computed(() => {
    const dateValue = toValue(date);
    if (!dateValue) return undefined;

    const localeInformation = locales.value.find((info) => {
      return typeof info !== "string" && info.code === locale.value;
    }) as LocaleObject | undefined;

    const intlLocale = localeInformation?.language || locale.value;

    let options: Intl.DateTimeFormatOptions = {
      // e.g. "19/12/2020, 22:23"
      dateStyle: "short",
      timeStyle: "short",
    };

    if (type === "time") {
      options = {
        // e.g. "22:23"
        timeStyle: "short",
      };
    }

    if (type === "date") {
      options = {
        weekday: "short", // e.g., "Fri"
        day: "2-digit", // e.g., "12"
        month: "short", // e.g., "Sept"
      };
    }

    if (type === "longDate") {
      options = {
        day: "numeric", // e.g., "7", "12"
        month: "long", // e.g., "December"
        year: "numeric", // e.g., "2023"
      };
    }

    return Intl.DateTimeFormat(intlLocale, options).format(dateValue);
  });

  return {
    localizedDateTime,
  };
};
